import React from 'react'
import { connect } from 'react-redux'
import { toggleRemarkScreen } from '../state/actions'  
import ActionButton from '../components/ActionButton'

class ActionButtonContainer extends React.Component {
  state = {
    pxTop: '-100px',
    pxRight: '-100px',
    isActive: false,
    isFixed: false // independently valued on a route change
  }
  
  domBody = null // DOM refs for position and size
  domAnchor = null // the element on the immediate left
  domActionButton = null // this element
  
  componentDidMount() {
    if(typeof window !== 'undefined') {
      window.addEventListener('resize', this.windowResizeHandler, false)
    }
    this.reCenterButton({stepwise: true})
  }
  
  // deprecated soon: componentWillMount, componentWillReceiveProps, componentWillUpdate
  componentWillUnmount() {
    if(typeof window !== 'undefined') {
      window.removeEventListener('resize', this.windowResizeHandler, false)
    }
  }

  componentWillReceiveProps(nextProps) {
    const overlayToggled = nextProps.remarkScreenIsActive !== this.props.remarkScreenIsActive

    // on action button click
    if (overlayToggled) {
      const opening = nextProps.remarkScreenIsActive
      const closing = !opening
      const action = { isActive: closing, isFixed: opening, }
      const onScreen = { pxRight: '20px', pxTop: '20px', }
      const offScreen = { pxRight: '-100px' } // pxTop keeps previous

      this.setState( 
        { ...action, ...(opening ? onScreen : offScreen) }, 
        () => closing && this.reCenterButton({stepwise: true})
      )
    }

    // on route change
    if (this.props.locationPathName !== nextProps.locationPathName) {
      this.domAnchor = null
      this.setState(
        { isActive: false, isFixed: false },
        () => this.reCenterButton({stepwise: true})
      )
    }
  }

  windowResizeHandler = () => {
    if (this.props.remarkScreenIsActive) 
      return false // not applicable to action button

    this.reCenterButton({stepwise: false})
  } 
  
  reCenterButton = ({stepwise}) => {

    this.domAnchor = this.domAnchor || document.querySelector('.js-action-button-anchor')
    this.domBody = this.domBody || document.querySelector('body')

    const buttonTop = this.domAnchor.offsetTop + 
                      (this.domAnchor.offsetHeight / 2) - 
                      (this.domActionButton.offsetHeight / 2)

    const buttonRight = this.domBody.offsetWidth - 
                        this.domAnchor.offsetLeft - 
                        this.domAnchor.offsetWidth - 
                        (this.domActionButton.offsetWidth * 1.5)                   

    if (stepwise) {
      setTimeout(
        () => {
          this.setState({ 
            isActive: true, 
            pxTop: `${buttonTop}px`
          },
          () => { setTimeout(() => {this.setState({ pxRight: `${buttonRight}px` })}, 300) })
        },
        300
      )
    } else {
      this.setState({
        isActive: true, 
        pxTop: `${buttonTop}px`,
        pxRight: `${buttonRight}px`
      })
    }
  }

  render() {
    return (     
      <ActionButton 
        onClick={this.props.buttonClickHandler}
        fnButtonRef={btn => this.domActionButton = btn}
        topPx={this.state.pxTop}
        rightPx={this.state.pxRight}
        isActive={this.state.isActive}
        isFixed={this.state.isFixed}
        locationPathName={this.props.locationPathName}
        classes={{
          block: 'c-action-button',
          isActive: 'c-action-button--is-active',
          isFixed: 'c-action-button--is-fixed'
        }}
      />
    )
  }
}

export default connect(
  (state, ownProps) => ({ remarkScreenIsActive: state.remarkScreen.isActive }), 
  (dispatch) =>  ({ buttonClickHandler: () => dispatch( toggleRemarkScreen() ) })
)(ActionButtonContainer)


// WEBPACK FOOTER //
// ./src/containers/ActionButtonContainer.jsx